var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2474 6.46463L19.7233 0.412902C19.2694 0.261609 18.8155 0.185962 18.3616 0.185962C17.8321 0.185962 17.3782 0.261609 16.9243 0.412902L2.40019 6.46463C1.03855 7.0698 0.20644 8.3558 0.20644 9.79308C0.20644 29.3099 14.5037 38.8414 18.286 38.8414C22.0683 38.8414 36.5168 29.4612 36.5168 9.79308C36.5168 8.3558 35.6091 7.0698 34.2474 6.46463ZM18.3616 35.2103C10.9483 32.1845 3.83748 22.653 3.83748 9.79308L18.3616 3.74135L32.8858 9.79308C32.8858 22.9556 25.3968 32.2601 18.3616 35.2103ZM14.1254 18.795C13.8228 18.4924 13.369 18.2655 12.9151 18.2655C11.856 18.2655 11.0996 19.0976 11.0996 20.081C11.0996 20.6105 11.2508 21.0644 11.6291 21.367L15.2601 24.9981C15.5627 25.3763 16.0166 25.5276 16.5461 25.5276C16.6974 25.5276 17.3782 25.4519 17.9077 24.8468L25.1698 16.3743C25.4724 16.0718 25.6237 15.6179 25.6237 15.2396C25.6237 14.6345 25.1698 13.4241 23.8082 13.4241C23.2787 13.4241 22.7491 13.5754 22.3709 14.0293L16.3948 21.0644L14.1254 18.795Z",
    fill: "#3CF09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxConfirm);
export default __webpack_public_path__ + "static/media/tx-confirm.af66936e00c1e87fba982d78086be565.svg";
export { ForwardRef as ReactComponent };